var map = {
	"./1.jpg": 99562,
	"./10.jpg": 75464,
	"./11.jpg": 2629,
	"./12.jpg": 80026,
	"./13.jpg": 43863,
	"./14.jpg": 62668,
	"./2.jpg": 91637,
	"./3.jpg": 87320,
	"./4.jpg": 34059,
	"./5.jpg": 56014,
	"./6.jpg": 36281,
	"./7.jpg": 49404,
	"./8.jpg": 93503,
	"./9.jpg": 85442
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 32359;